var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"icon":""},on:{"click":_vm.toggleLang}},[_c('img',{attrs:{"src":_vm.locale === 'fr' ? _vm.flagFr : _vm.flagEn,"alt":"flag","width":"24","height":"24","cover":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }